module.exports = __webpack_public_path__ + "media/images/hero_header/hero_header2-e691fde051f09d9672167eefb79b5d71.jpeg";